module.exports = __webpack_public_path__ + "static/media/Block by Block_20191010_134448-1051986585.9f898705.jpg";